import React, { useContext, useEffect, useState } from 'react'
import DocumentsDataTable from '../../../components/DocumentsDataTable';
import { WorkerDocument } from '../../../app/models/Workers';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import useWorkerDocumentService from '../../../app/services/hooks/useWorkerDocumentService';
import { toast } from 'react-toastify';
import { DocumentNameFilters } from '../../../app/models/Document';
import { useHistory } from 'react-router-dom';
import DefaultModal from '../../../components/default/DefaultModal';
import WorkerDocumentHistory from '../../Workers/components/WorkerDocumentHistory';
import { Worker } from '../../../app/models/Workers';
import WorkerDocumentCreate from '../../Workers/components/WorkerDocumentCreate'
import { BankAccount } from '../../../app/models/BankAccountType';
import useBankAccountService from '../../../app/services/hooks/useBankAccount';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { AppContext } from '../../../contexts/AppContext';
import { AuthContext } from '../../../contexts/AuthContext';
import ButtonCreate from '../../../components/buttons/ButtonCreate';
import { DocumentSet } from '../../../app/models/DocumentSet';
import WorkerDocumentEdit from '../../Workers/components/WorkerDocumentEdit';
import { UserDataForm } from '../../../app/models/User';
import useWorkerService from '../../../app/services/hooks/useWorkerService';
import DefaultCard from '../../../components/default/DefaultCard';

interface Props {
    profile: UserDataForm;
}

const ProfileDocumentContainer = ({ profile }: Props) => {

    const history = useHistory();
    const { getWorkerDocumentsByWorker, 
        getWorkerDocumentBySet,
        deleteWorkerDocument, 
        fetchingGetWorkerDocuments } = useWorkerDocumentService();

    const { getWorkerByUser, 
        fetchingByUser } = useWorkerService();
        
    const { showLoading, hideLoading } = useContext(AppContext);
    const { auth } = useContext(AuthContext);

    const [workerDocuments, setWorkerDocuments] = useState<WorkerDocument[]>([]);
    const [documentTypes, setDocumentTypes] = useState<any[]>([]);
    const [filter, setFilter] = useState<DocumentNameFilters>({document_name: ''});
    const [showingHistoryDocument, setShowingHistoryDocument] = useState(false);
    const [showingCreateDocument, setShowingCreateDocument] = useState(false);
    const [showingEditDocument, setShowingEditDocument] = useState(false);
    const [typeDocumentSelected, setTypeDocumentSelected] = useState<any>();

    const [worker, setWorker] = useState<any>();
    const [documentSets, setDocumentSets] = useState<any>();

    useEffect(() => {
        if(profile.id){
            getWorkerByUser(profile.id, {
                onSuccess: (response: ServiceResponse) => {
                    setDocumentSets(response.data.worker.document_sets);
                    const _worker = response.data.worker;
                    if (response.data.worker.document_sets) {
                        _worker.document_sets = response.data.worker.document_sets.map(
                            (docSet: any) => {
                                return {
                                    value: docSet.id,
                                    label: docSet.name
                                };
                            }
                        );
                    }
                    setWorker(_worker);
                },
                onError: (response: ServiceResponse) => {
                    toast.error(response.message);
                    if (response.data.to_dashboard) {
                        history.goBack();
                    }
                }
            });
        }

    }, []);

    useEffect(() => {
        if(worker && worker.id){
            getDocuments(Number(worker?.id));
        }
    }, [worker]);

    const getDocuments = (id: number) => {
        getWorkerDocumentsByWorker(id, filter, {
            onSuccess: (response: ServiceResponse) => {
                setWorkerDocuments(response.data.worker_documents);
                setDocumentTypes(response.data.worker_documents);
            },
            onError: (response: ServiceResponse) => {
                toast.error(response.message);
                if (response.data.to_dashboard) {
                    history.goBack();
                }
            }
        });
    };

    const destroyDocument = (DocumentId: number) => {
        const _text = 'Está a punto de eliminar el documento de el Trabajador #' + Number(worker?.id);

        useReactConfirmAlert().requestConfirmation({
            title: '¿Estás seguro?',
            message: _text,
            buttons: {
                confirmButton: {
                    label: 'Si, confirmar',
                    onClick: () => {
                        if (showLoading) showLoading('loading', 'Eliminando documento...');
                        deleteWorkerDocument(Number(worker?.id),DocumentId, {
                            onSuccess: (response: ServiceResponse) => {
                                if (hideLoading) hideLoading();

                                useReactConfirmAlert().successAlert({
                                    title: 'Éxito',
                                    message: response.message
                                });

                                reloadDocumentsTable();

                            },
                            onError: (response: ServiceResponse) => {
                                if (hideLoading) hideLoading();

                                useReactConfirmAlert().errorAlert({
                                    title: 'Error',
                                    message: response.message
                                });
                            }
                        });
                    }
                },
                cancelButton: {
                    label: 'No, cancelar',
                    onClick: () => {
                        setTimeout(() => {
                            useReactConfirmAlert().infoAlert({
                                title: 'Cancelado',
                                message: 'El documento no se ha eliminado.'
                            });
                        }, 0);
                    }
                }
            }
        });
    };

    const handleGetDocumentSet = (documentSetId: number): void => {
        getWorkerDocumentBySet(Number(worker?.id), documentSetId);
    };
    

    const showCreateDocument = (type: string) => {
        setTypeDocumentSelected(type);
        setShowingCreateDocument(true);
    };

    const hideCreateDocument = () => {
        setShowingCreateDocument(false);
    };

    const showHistoryDocument = (type: string) => {
        setTypeDocumentSelected(type);
        setShowingHistoryDocument(true);
    };

    const hideHistoryDocument = () => {
        setShowingHistoryDocument(false);
    };

    const reloadDocumentsTable = () => {
        getDocuments(Number(worker?.id));
    };

    const showEditDocument = (type: string) => {
        setTypeDocumentSelected(type);
        setShowingEditDocument(true);
    };

    const hideEditDocument = () => {
        setShowingEditDocument(false);
    };

    return (
        <div>

            {
                worker && documentSets && (
                    <div>
                        <DefaultCard>
                            <div className="h3 mt-0 mb-2 card-title">
                                Documentos
                            </div>
                            <DocumentsDataTable
                                data={workerDocuments}
                                create={showCreateDocument}
                                showHistory={showHistoryDocument}
                                edit={showEditDocument}
                                destroy={destroyDocument}
                                progressPending={fetchingGetWorkerDocuments}
                                filter={filter}
                                setFilter={setFilter}
                                onSearch={reloadDocumentsTable}
                                documentSets={documentSets}
                                getDocumentSet={handleGetDocumentSet}
                                documentType="worker"
                            />
                        </DefaultCard>
                    </div>
                )
            }



            {showingCreateDocument ? (
                <DefaultModal
                    show={showingCreateDocument}
                    handleClose={hideCreateDocument}
                    title="Agregar Documento"
                    backdrop={true}
                    showFooter={false}
                >
                    <WorkerDocumentCreate
                        onSaved={() => {
                            hideCreateDocument()
                            reloadDocumentsTable();
                        }}
                        typeDocument={typeDocumentSelected}
                        workerId={Number(worker?.id)}
                        onCancel={hideCreateDocument}
                        onError={hideCreateDocument}
                    />
                </DefaultModal>
            ) : null}

            {showingEditDocument ? (
                <DefaultModal
                    show={showingEditDocument}
                    handleClose={hideEditDocument}
                    title="Editar Fechas del Documento"
                    backdrop={true}
                    showFooter={false}
                >
                    <WorkerDocumentEdit
                        onSaved={() => {
                            hideEditDocument()
                            reloadDocumentsTable();
                        }}
                        typeDocument={typeDocumentSelected}
                        workerId={Number(worker?.id)}
                        onCancel={hideEditDocument}
                        onError={hideEditDocument}
                    />
                </DefaultModal>
            ) : null}

            {showingHistoryDocument ? (
                <DefaultModal
                    show={showingHistoryDocument}
                    handleClose={hideHistoryDocument}
                    title={`Historial de documentos de ${
                        documentTypes?.find(
                            (workerDoc: any) =>
                                workerDoc.id === typeDocumentSelected
                        ).document_name
                    }`}
                    backdrop={true}
                    size={'lg'}
                    showFooter={false}
                >
                    <WorkerDocumentHistory
                        typeDocument={typeDocumentSelected}
                        workerId={Number(worker?.id)}
                        onCancel={hideHistoryDocument}
                        onError={hideHistoryDocument}
                    />
                </DefaultModal>
            ) : null}

        </div>
    )
}

export default ProfileDocumentContainer
